import { render, staticRenderFns } from "./LogDetail.vue?vue&type=template&id=67b3a9fd&scoped=true&"
import script from "./LogDetail.vue?vue&type=script&lang=js&"
export * from "./LogDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogDetail.vue?vue&type=style&index=0&id=67b3a9fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3a9fd",
  null
  
)

export default component.exports